class DashboardController {
  constructor() {
    let vm = this;
    vm.name = 'dashboard';
  }
}

export default DashboardController;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/dashboard.controller.js